import { Component, OnInit, NgZone, AfterViewInit, ɵConsole, IterableDiffers} from '@angular/core';
import { AuthService } from "../../shared/services/auth.service";

import { AngularFirestore, AngularFirestoreCollection, AngularFirestoreDocument } from '@angular/fire/firestore';
import { Observable } from 'rxjs';
import { Router } from "@angular/router";
import {MenuItem} from 'primeng/api';

export interface Item { title: string; start: string;}

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html'
})
export class DashboardComponent implements OnInit, AfterViewInit{
  private itemsCollection: AngularFirestoreCollection<Item>;
          items: Observable<Item[]>;
  menuitems: MenuItem[];
  userRole: any;
  displayAdmin: boolean = false;
  data: any;
  times: any;
  chartDataDate: any;
  chartDataTime: any;
  chartDataTimeCount: any;
  ref: any;

  constructor(
    public authService: AuthService,
    public router: Router,
    public ngZone: NgZone,
    private afs: AngularFirestore,
  ) { 
    // console.log(this.authService.afAuth.auth.currentUser.uid);
    // this.itemsCollection2 = this.afs.collection<Item>('users/' + this.authService.afAuth.auth.currentUser.uid);
    // this.items2 = this.itemsCollection.valueChanges();
  }

  ngOnInit() { 
    this.authService.isAdmin(this.authService.afAuth.auth.currentUser.uid);
    this.adminContent();
  }

  adminContent(){
    if(this.authService.adminContent == true){
      this.displayAdmin = true;
    }else{
      this.displayAdmin = false;
    }
  }

  ngAfterViewInit(){
    this.itemsCollection = this.afs.collection<Item>('users/' + this.authService.afAuth.auth.currentUser.uid + '/attendance', ref => ref.orderBy('time', "desc"));
    this.items = this.itemsCollection.valueChanges();
    // Is Admin (Display Admin content if true)
    this.authService.isAdmin(this.authService.afAuth.auth.currentUser.uid);
    this.adminContent();
    // Count for Attendance (Amount of Logs for set User)
    this.itemsCollection.valueChanges().subscribe(data => this.chartDataTimeCount = data.length);

    // Reference to Firebase (Current User Attendance)
    this.ref = this.afs.collection<Item>('users/' + this.authService.afAuth.auth.currentUser.uid + '/attendance', ref => ref.orderBy('time', "asc"));
    // Catch any update to draw the Chart
    this.ref.valueChanges().subscribe(result => {
      var dates = [];
      var times = [];
      for(var item in result){
        let checkInDate = new Date(result[item].time).toLocaleDateString()
        let checkInTime = new Date(result[item].time).getHours();
        let checkInTimeMin = new Date(result[item].time).getMinutes();
        let checkInTimeSec = new Date(result[item].time).getSeconds();
        dates.push(checkInDate);
        times.push(checkInTime + "" + checkInTimeMin + "." + checkInTimeSec);
        this.times = checkInTime + ":" + checkInTimeMin + " " + checkInDate;
    }
    this.chartDataDate = JSON.stringify(dates);
    this.chartDataTime = times;

    //Chart Data (Label = Dates) (Data = Times)
    this.data = {
      labels: dates,
      datasets: [
          {
              label: 'Check-In Time',
              data: times,
              borderColor: '#43425d'
          },
      ]
  }
})

  this.menuitems = [
    {label: 'Status: Online', icon: 'pi pi-fw pi-plus'},
    {label: 'Help Centre', icon: 'pi pi-fw pi-download', routerLink: ['/help-centre']},
    {label: 'Logout', icon: 'pi pi-fw pi-refresh', command: () => this.authService.SignOut()}
]

  }
}
